import { observer } from 'mobx-react';
import PinIndicator from './PinIndicator';
import useJoinPinSettingView from '../useJoinPinSettingView';
import { INPUT_MSG } from '@/consts/message';
import Spinner from '@/components/Spinner';

const JoinPinSettingView = observer(() => {
  const {
    pin,
    checkPin,
    isCheckView,
    isPinCheckFailed,
    isCompleteModalOpen,
    isFailedModalOpen,
    failedMessage,
    isLoading,
    onClickNumberBtn,
    OnClickDeleteBtn,
    onClickAllClearBtn,
    onClickCompleteConfirm,
    onClickCompleteClose,
    onClickFailedModalConfirm,
  } = useJoinPinSettingView();

  return (
    <div className="page-container">
      <div className="page-content pin-content">
        <div className="pin-header">
          <h1 className="pin-title heading-4 font-bold">
            {isCheckView ? 'PIN 비밀번호 확인' : 'PIN 비밀번호 설정이 필요합니다.'}
          </h1>
          <p className="pin-subtitle text-sm font-semibold">
            {isCheckView ? '다시 한번 입력해주세요.' : '6자리 숫자로 입력해주세요.'}
          </p>
        </div>

        <PinIndicator pin={pin} checkPin={checkPin} isCheckView={isCheckView} />

        <p className="pin-notice text-sm font-semibold">
          {isPinCheckFailed ? INPUT_MSG.PIN_CHECK_FAILED : '거래시 보안을 위해 PIN 비밀번호가 필요합니다.'}
        </p>

        <div className="pin-keypad">
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="1"
            onClick={() => onClickNumberBtn('1')}
          >
            1
          </button>
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="2"
            onClick={() => onClickNumberBtn('2')}
          >
            2
          </button>
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="3"
            onClick={() => onClickNumberBtn('3')}
          >
            3
          </button>

          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="4"
            onClick={() => onClickNumberBtn('4')}
          >
            4
          </button>
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="5"
            onClick={() => onClickNumberBtn('5')}
          >
            5
          </button>
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="6"
            onClick={() => onClickNumberBtn('6')}
          >
            6
          </button>

          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="7"
            onClick={() => onClickNumberBtn('7')}
          >
            7
          </button>
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="8"
            onClick={() => onClickNumberBtn('8')}
          >
            8
          </button>
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="9"
            onClick={() => onClickNumberBtn('9')}
          >
            9
          </button>

          <button
            type="button"
            className="pin-key pin-key-clear text-base font-medium"
            id="pinClearBtn"
            onClick={onClickAllClearBtn}
          >
            전체삭제
          </button>
          <button
            type="button"
            className="pin-key heading-2 font-bold"
            data-number="0"
            onClick={() => onClickNumberBtn('0')}
          >
            0
          </button>
          <button type="button" className="pin-key pin-key-delete" id="pinDeleteBtn" onClick={OnClickDeleteBtn}>
            <img src="./images/delete-icon.png" alt="삭제" className="pin-key-delete-icon" />
          </button>
        </div>
      </div>

      {/* 회원가입 완료 모달 */}
      {isCompleteModalOpen && (
        <div className="modal-overlay" id="signupCompleteModal">
          <div className="modal-content modal-medium">
            <button type="button" className="modal-close" id="signupCompleteClose" onClick={onClickCompleteClose}>
              <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
            </button>

            <div className="modal-body">
              <img src="./images/success-icon.png" alt="완료" className="modal-icon" />
              <p className="modal-message text-base font-semibold">회원가입이 완료되었습니다.</p>
              <button
                type="button"
                className="modal-button text-lg font-semibold"
                id="signupCompleteConfirm"
                onClick={onClickCompleteConfirm}
              >
                확인
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 회원가입 실패 모달 */}
      {isFailedModalOpen && (
        <div className="modal-overlay" id="signupFailedModal">
          <div className="modal-content modal-medium">
            <button type="button" className="modal-close" onClick={onClickFailedModalConfirm}>
              <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
            </button>

            <div className="modal-body">
              <div className="modal-icon-warning">
                <img src="./images/alert-icon.png" alt="경고" className="modal-icon" />
              </div>
              <p className="modal-message text-base font-semibold">{failedMessage}</p>
              <button
                type="button"
                className="modal-button text-lg font-semibold"
                onClick={onClickFailedModalConfirm}
              >
                확인
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 로딩 스피너 */}
      {isLoading && <Spinner text="회원가입 중..." />}
    </div>
  );
});

export default JoinPinSettingView;
